import { environment } from '../../../environments/environment';

export const CONST = {
  STORAGE_KEYS: {
    ACCESS_TOKEN: 'cc_access_token',
    REFRESH_TOKEN: 'cc_refresh_token',
    RETURN_URL: 'cc_return_url',
    CREATE_COURSE_ID: 'cc_create_course',
    ZOOM_ACCESS_TOKEN: 'cc_zoom_access_token',
    ZOOM_REFRESH_TOKEN: 'cc_zoom_refresh_token',
    ZOOM_RETURN_URL: 'cc_zoom_return_url',
    ZOOM_OAUTH_STATE: 'cc_zoom_oauth_state',
    IMPERSONATION_ADMIN_TOKEN: 'cc_impersonation_admin_token',
    IMPERSONATION_ADMIN_REFRESH_TOKEN: 'cc_impersonation_admin_refresh_token',
  },
};

export function getApiHostUrl() {
  return environment.host;
}

export function getUploadProcessURL() {
  return environment.host + '/api/v1/upload/filepond';
}

export function getUploadRevertURL() {
  return environment.host + '/api/v1/upload/revert';
}

export function getLoadResourceURL() {
  return environment.host + '/api/v1/upload/load';
}

export function getUploadResumeURL() {
  return environment.host + '/api/v1/upload/resumable';
}

export function getZoomTokenURL() {
  return environment.host + '/api/v1/auth/zoom-token';
}
